__turbopack_context__.v({
  "textfield": "Textfield-module-scss-module__vBm2IG__textfield",
});
